import PropTypes from 'prop-types';
import Card from 'components/UI/Card';
import documentIcon from 'assets/icons/document.svg';

const NotificationCard = ({ item, onOpen }) => {
  return (
    <Card
      title={item.title}
      description={item.message}
      image={documentIcon}
      imageClassName='max-h-10 max-w-10'
      onClick={() => onOpen(item.id)}
    />
  );
};

NotificationCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
  }).isRequired,
  onOpen: PropTypes.func.isRequired,
};

export default NotificationCard;
